import { Component, h, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { TrackableContentId } from '../../types/global';

export interface UiCmsNewsletterCtaBody extends TrackableContentId {
  headline: string;
  text: string;
  newsletterPageUrl: string;
  mailQueryParameter?: string;
}

@Component({
  tag: 'ui-cms-newsletter-cta',
  styleUrl: 'ui-cms-newsletter-cta.scss',
})
export class UiCmsNewsletterCta {
  @Prop() variant: 'white';

  @Prop({ mutable: true }) body: UiCmsNewsletterCtaBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Prop({ mutable: true }) i18n = {
    signup: 'Anmelden',
    yourEmail: 'Ihre E-Mail-Adresse',
  };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  componentWillLoad() {
    this.utilityI18nChangeHandler(this.utilityI18n);
    this.bodyChangeHandler(this.utilityBody);
  }

  onFormSubmit() {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Click Newsletter Call to Action',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: this.i18n.signup,
        target: this.body.contentId,
      },
      category: {
        area: 'Content',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    return (
      <div class="newsletter">
        <ui-headline level={4} iconVariant={this.variant}>
          {this.body.headline}
        </ui-headline>
        <p innerHTML={this.body.text}></p>
        <form action={this.body.newsletterPageUrl} class="newsletter__form">
          <ui-input
            type="email"
            placeholder={this.i18n.yourEmail}
            name={this.body.mailQueryParameter ? this.body.mailQueryParameter : 'email'}
          ></ui-input>
          <ui-button type="submit" variant="primary" onClick={() => this.onFormSubmit()}>
            {this.i18n.signup}
          </ui-button>
        </form>
      </div>
    );
  }
}
